import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const InformationRetrievalExtractionPerception = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Information Retrieval- Information Extraction-Perception"
    videos={[
      "https://www.youtube.com/embed/rBGdjv-Scko"
    ]}
    takeaways={[]}
    questions={[
      "Imagine you're searching for information on a complex topic like 'climate change'. Explain, how search engines would identify pages that are most authoritative and informative pages on this topic without repetitive or irrelevant content with suitable examples."
    ]}
    exampleVideos={[]}
  />
);
}

export default InformationRetrievalExtractionPerception;
